<template>
  <div>
    <el-table
      :data="menuArr"
      :row-class-name="tableRowClassName">
      <el-table-column
        label="上级菜单"
        width="200">
        <template scope="scope">
          <span>{{ menusById[scope.row.pid] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="菜单名称"
        width="200">
        <template scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="菜单类型"
        width="150">
        <template scope="scope">
          <span>{{ scope.row.menu_type | menuType }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="模块"
        width="200">
        <template scope="scope">
          <span>{{ scope.row.module }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="排序"
        width="100">
        <template scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        width="150">
        <template scope="scope">
          <span>{{ scope.row.status | status }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="绑定权限规则"
        width="300">
        <template scope="scope">
          <span>{{ scope.row.rule_name }} </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200">
        <template scope="scope">
          <div class="p-t-10 p-b-10">
<!--             <span>
              <el-button size="small" type="primary" @click="resetMenu(scope.$index)">重置</el-button>
            </span> -->
            <span>
              <el-button size="small" type="primary" @click="setCurMenu(scope.row, scope.$index)">配置</el-button>
            </span>
            <span>
              <el-button size="small" @click="deleteMenu(scope.$index)">清空</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    props: {
      menu: {
        type: Object,
        default() {
          return {}
        }
      },
      menusById: Object,
      default() {
        return {}
      }
    },
    data() {
      return {
        menuArr: [],
        curIndex: ''
      }
    },
    created() {
      if (JSON.stringify(this.menu) == '{}') {
        this.menuArr = []
      } else {
        this.menuArr.push(this.menu)
      }
    },
    methods: {
      tableRowClassName(row, index) {
        if (index === this.curIndex) {
          return 'info-row'
        }
        return ''
      },
      resetIndex() {
        this.curIndex = ''
      },
      deleteMenu(index) {
        this.resetIndex()
        this.menuArr = []
        this.$emit('deleteMenu', index)
      },
      setCurMenu(item, index) {
        this.$emit('setCurMenu', item)
        this.curIndex = index
      },
      resetMenu(index) {
        this.$emit('resetMenu', index)
      }
    },
    watch: {
      'menu'() {
        if (JSON.stringify(this.menu) != '{}') {
          this.menuArr = []
          this.menuArr.push(this.menu)
        } else {
          this.menuArr = []
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// menuTable.vue?4d6afb78